<p class="answer">
  <strong>Host&rsquo;s Private Property:</strong> CurbNTurf&rsquo;s calculator adds the following surcharges to the Host
  defined take home price per site per night: 1.) The greater of ${{ minimumFee }} fee or {{ percentageFee }}%
  commission fee; and, 2.) ${{ feedbackIncentive }} CurbNTurf Cash Guest Incentive.
</p>
<p class="answer">
  Upon the completion of a reservation and stay CurbNTurf receives a portion of the financial transaction as commission
  for its services as the commission fee outlined above.
</p>
<p class="answer">
  Upon the completion of a reservation, stay, and leaving an honest experience review the Guest receives the CurbNTurf
  Cash Guest Incentive portion of the transaction outlined above. This is received by the Guest as CurbNTurf Cash and is
  designed to be an incentive used toward future reservations. Or it can be withdrawn as defined in the CurbNTurf Cash
  section.
</p>
<p class="answer">
  <strong>Boondocking:</strong> To support the going concern of CurbNTurf, donations to virtual bookings at Boondocking
  sites are split between the listing caretaker and CurbNTurf equally 50/50. The user will receive their donated portion
  as CurbNTurf cash.
</p>
<div class="faq-question-bar date">
  <div class="rift-soft-title">06/2019</div>
</div>
